import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  CardModalView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import CardMoveAction from 'components/CardActions/Move'

export class MoveCard extends React.Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,

    cardId: PropTypes.number.isRequired,

    leftSidebar: PropTypes.object.isRequired,

    boardId: PropTypes.number.isRequired,

    requestMoveCard: PropTypes.func.isRequired
  }

  handleMove = ({ boardId, statusId }) => {
    const { cardId, leftSidebar, modalId, requestMoveCard } = this.props

    requestMoveCard({
      boardId,
      cardId,
      statusId,
    })

    leftSidebar.remove(modalId)
  }

  render () {
    const {
      boardId
    } = this.props

    return (
      <CardModalView
        title={<FormattedMessage id='CARD_MOVE_HEADER' />}
      >
        <ViewBody>
          <CardMoveAction
            currentBoardId={boardId}
            onMove={this.handleMove}
          />
        </ViewBody>
      </CardModalView>
    )
  }
}

export default withLeftSidebar(MoveCard)

